

















































































import { mapActions, mapState } from "vuex";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconBalloonPresentBox from "@/common/components/icons/IconBalloonPresentBox.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import modalState from "@/common/store/modules/modalState";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import CONST_DATA from "@/general/mixins/const/constData";
import LocalStorage from "@/general/utils/storage";
@Component({
  components: {
    ModalMain,
    PointNotation,
    SmallText,
    ButtonMain,
    IconUserImage,
    IconBalloonPresentBox
  },
  ...mapState({
    colorCode: () => commons.colorCode
  })
})
export default class ModalCompletedThanksPointSend extends Vue {
  @Prop({ type: [Object, Boolean], default: false }) modalCompleteData: any;
  @Prop({ type: String, default: "サンクスポイントを送付しました" })
  heading!: string;

  get urlPointConfirmation() {
    return CONST_DATA.SITE_MAP.POINT_CONFIRMATION;
  }

  get headingText() {
    return this.heading;
  }

  get icon() {
    return this.modalCompleteData.sendTo.icon.medium;
  }

  get name() {
    return this.modalCompleteData.sendTo.name;
  }

  get sendPoint() {
    const sendPoint = LocalStorage.getItem("points_to_send") as any;
    return sendPoint;
  }

  get date() {
    const date = new Date();
    const formatedDate =
      date.getFullYear().toString() +
      "年" +
      (date.getMonth() + 1).toString() +
      "月 " +
      date.getDate().toString() +
      "日 " +
      ("0" + date.getHours()).slice(-2).toString() +
      ":" +
      ("0" + date.getMinutes()).slice(-2).toString();
    return formatedDate;
  }

  get profileIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 80 : 144;
  }

  get balloonIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 70 : 100;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  closeModal() {
    modalState.changeModal("");
  }
}
